<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner :animation-duration="2000" :size="80" color="#63c2de" class="offset-6"></semipolar-spinner>
        </div>
        <table-pages
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fas fa-address-card mr-2'></i> Páginas de Facebook</h4>"
          v-else
        ></table-pages>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TablePages from "./TablePages";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";

import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";

export default {
  name: "facebookPages",
  components: {
    TablePages,
    SemipolarSpinner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "page_id", label: "ID page", sortable: true },
        { key: "create_date", label: "Creado", sortable: true },
        {key:"acciones",label: "Acciones"}
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getPages();
  },
  methods: {
    getPages() {
      var pages = store.getters.getFacebookPages;
      if (pages.length == 0) {
        this.isLoading = true;
        store.dispatch("getFacebookPages").then(() => {
          store.dispatch("getStereotypes");
          pages = store.getters.getFacebookPages;
          shuffleArray([pages]);
          this.isLoading = false;
          this.items = pages;
          this.itemsArray = pages;
        });
      } else {
        shuffleArray([pages]);
        this.items = pages;
        this.itemsArray = pages;
      }
    }
  }
};
</script>
